export const FETCH_AVAILABLE_REPORTEES = 'FETCH_AVAILABLE_REPORTEES';
export const INIT_WIZARD_STEPS = 'INIT_WIZARD_STEPS';
export const UPDATE_ATTACHMENT = 'UPDATE_ATTACHMENT';
export const UPDATE_CONVERTED_ATTACHMENT = 'UPDATE_CONVERTED_ATTACHMENT';
export const UPDATE_MESSAGE_ID = 'UPDATE_MESSAGE_ID';
export const UPDATE_SELECTED_NEXT_PROCESS_CATEGORY = 'UPDATE_SELECTED_NEXT_PROCESS_CATEGORY';
export const UPDATE_SELECTED_REPORTEE = 'UPDATE_SELECTED_REPORTEE';
export const UPDATE_WIZARD_STEP = 'UPDATE_WIZARD_STEP';
